import React from 'react'
import ContributionsPageSkeleton from './components/ContributionsComponents/ContributionsPageSkeleton'
import SkeletonAnimationSyncDecorator from '../common/SkeletonAnimationSyncDecorator'

export default function ChangeLogPageSkeleton(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <ContributionsPageSkeleton />
    </SkeletonAnimationSyncDecorator>
  )
}
